import { Box, Grid, Tab, Tabs, Typography, TextField, Chip, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined'
import ProgressAllSlider from 'components/ProgressAllSlider';
import ProgressAcademyIASlider from 'components/ProgressAcademyIASlider';
import { Autocomplete } from '@material-ui/lab';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CourseData, LessonData, TrailData, AcademyiaData } from 'services/dataService/index';
import { StudentContentHeader } from 'views/StudentContent/components';
import { useStyles } from './styles';
import { Link, useLocation } from 'react-router-dom';
import { format } from 'date-fns';
import { RatingData } from 'services/dataService';
import ModalPlatform from 'components/RatingPlatform/components/ModalPlatform/Index';
import CircularProgress from '@mui/material/CircularProgress';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default () => {
  const classes = useStyles();
  const { company, auth } = useSelector((state) => state);
  const { id: userId } = auth || {};
  const { t } = useTranslation(['label', 'toastify', 'tables', 'menu', 'views']);
  const history = useHistory();
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const tabFromUrl = parseInt(query.get('tab')) || 0;
  const [tab, setTab] = useState(tabFromUrl);

  const [type, setType] = useState('all');

  const [isLoading, setIsLoading] = useState(true);

  const [courses, setCourses] = useState([]);
  const [startCourses, setStartCourses] = useState([]);
  const [finishedCourses, setFinishedCourses] = useState([]);
  const [courseList, setCourseList] = useState([]);
  const [courseCategories, setCourseCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const [trails, setTrails] = useState([]);
  const [startTrails, setStartTrails] = useState([]);
  const [finishedTrails, setFinishedTrails] = useState([]);
  const [trailList, setTrailList] = useState([]);

  const [academy, setAcademy] = useState({});
  const [academyList, setAcademyList] = useState([]);
  const [selectedAcademy, setSelectedAcademy] = useState(null);
  const [filteredAcademy, setFilteredAcademy] = React.useState(null);
  const [academyName, setAcademyName] = React.useState(null);

  const [showCourses, setShowCourses] = useState(true);
  const [showTrails, setShowTrails] = useState(true);

  const [selectedItem, setSelectedItem] = useState(null);
  const [filteredList, setFilteredList] = useState([]);
  const [courseTrailsIndex, setCourseTrailsIndex] = useState(new Map());
  const [selectedItemTrailIds, setSelectedItemTrailIds] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [error, setError] = useState(false);

  const [openRating, setOpenRating] = useState(false);
  const [filterType, setFilterType] = useState('all');

  const CustomTab = withStyles({
    root: {
      border: '1px solid #176AE6',
      color: '#176AE6',
      borderRadius: '4px',
      marginRight: '10px',
    },
    selected: {
      backgroundColor: '#176AE6',
      color: '#fff !important',
    },
  })(Tab);

  useEffect(() => {
    onShouldOpenModalRating();
    loadAllData();
  }, []);

  const loadAllData = async () => {
    setIsLoading(true);
    await Promise.all([loadCourses(), loadTrails(), loadAcademyIa(), loadCourseTrailsIndex()]);
    setIsLoading(false);
  };

  const loadCourses = async () => {
    try {
      const { data: coursesData } = await CourseData.getMyContentCourses(userId);
      const categoryCourses = coursesData?.categoryCourses || [];
      setCourseCategories(
        categoryCourses
          .map((category) => category?.name)
          .filter(Boolean)
          .sort((a, b) => a.localeCompare(b, undefined, { ignorePunctuation: true, sensitivity: 'accent' }))
      );

      const categoryByCompanyCourseId = new Map();
      const categorizedCourses = categoryCourses.flatMap((category) =>
        (category?.courses || []).map((course) => {
          const idCompanyCourse = course?.id_company_course || course?.company_course?.id;
          const normalized = {
            ...course,
            category_name: category?.name || '',
          };

          if (idCompanyCourse) {
            categoryByCompanyCourseId.set(idCompanyCourse, normalized.category_name);
          }

          return normalized;
        })
      );

      const appendCategory = (list = []) =>
        list.map((item) => {
          const idCompanyCourse = item?.id_company_course || item?.company_course?.id;
          return {
            ...item,
            category_name: item?.category_name || categoryByCompanyCourseId.get(idCompanyCourse) || '',
          };
        });

      const finished = appendCategory(coursesData?.finishedCourses || []);
      const sortedFinished = finished.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { ignorePunctuation: true, sensitivity: 'accent' })
      );
      setFinishedCourses(sortedFinished);


      const inProgressResp = appendCategory((await CourseData.getCourseInProgress(userId)).data || []);
      const progressZero = inProgressResp.filter((c) => c.course_progress < 1)
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { ignorePunctuation: true, sensitivity: 'accent' }));
      const inProgress = inProgressResp.filter((c) => c.course_progress > 0)
        .sort((a, b) => (a.course_progress < b.course_progress ? 1 : -1));

      setStartCourses(progressZero);
      setCourses(inProgress);

      const mergedCourses = [...categorizedCourses, ...sortedFinished, ...inProgressResp].reduce((acc, current) => {
        const idCompanyCourse = current?.id_company_course || current?.company_course?.id;
        const lessons = current?.courses?.lessons || current?.company_course?.course?.lessons || [];
        const hasLessons = lessons.length > 0;

        if (!idCompanyCourse) return acc;

        const existing = acc.get(idCompanyCourse);

        if (!existing) {
          acc.set(idCompanyCourse, current);
          return acc;
        }

        const existingLessons = existing?.courses?.lessons || existing?.company_course?.course?.lessons || [];
        if (existingLessons.length === 0 && hasLessons) {
          acc.set(idCompanyCourse, current);
        }

        return acc;
      }, new Map());

      setCourseList(Array.from(mergedCourses.values()));
    } catch (err) {
      toast.error(t('toastify:commons.toast_error_api'));
    }
  };

  const loadTrails = async () => {
    try {
      const trailData = (await TrailData.getTrailUser(userId)).data || [];

      const progressZero = trailData
        .filter((t) => Number(t.progress) === 0)
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { ignorePunctuation: true, sensitivity: 'accent' }));

      const inProgress = trailData
        .filter((t) => Number(t.progress) > 0 && Number(t.progress) < 100)
        .sort((a, b) => (a.progress < b.progress ? 1 : -1));

      const finished = trailData
        .filter((t) => Number(t.progress) === 100)
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { ignorePunctuation: true, sensitivity: 'accent' }));

      setStartTrails(progressZero);
      setTrails(inProgress);
      setFinishedTrails(finished);
      setTrailList([...progressZero, ...inProgress, ...finished]);
    } catch (err) {
      toast.error(t('toastify:commons.toast_error_api'));
    }
  };

  const loadCourseTrailsIndex = async () => {
    try {
      const { data } = await TrailData.getCourseTrailIndex(userId);

      const index = new Map();
      (data || []).forEach((row) => {
        const idCompanyCourse = row?.id_company_course;
        const idTrail = row?.id_trail;
        if (!idCompanyCourse || !idTrail) return;

        const trailIds = index.get(idCompanyCourse) || [];
        if (!trailIds.includes(idTrail)) trailIds.push(idTrail);
        index.set(idCompanyCourse, trailIds);
      });

      setCourseTrailsIndex(index);
    } catch (err) {
      toast.error(t('toastify:commons.toast_error_api'));
    }
  };

  const loadAcademyIa = async () => {
    try {
      const response = await AcademyiaData.getAcademyIa();
      const data = response?.data?.academyia || [];
      const groupedByCategory = data.reduce((acc, item) => {
        const categoryName = item.categories?.name || 'Sem categoria';
        if (!acc[categoryName]) acc[categoryName] = [];
        acc[categoryName].push(item);
        return acc;
      }, {});
      setAcademy(groupedByCategory);
      setAcademyList(data);
    } catch (err) {
      toast.error(t('toastify:commons.toast_error_api'));
    }
  };

  const normalizeText = (text = '') =>
    text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

  const getCourseLessons = (item) =>
    item?.courses?.lessons || item?.company_course?.course?.lessons || item?.lessons || [];

  const getItemType = (item) => {
    if (!item) return null;
    if (item?.id_company_course || item?.company_course) return 'course';
    return 'trail';
  };

  const getItemIdentity = (item) => {
    if (!item) return null;
    if (getItemType(item) === 'course') {
      return item?.id_company_course || item?.company_course?.id || null;
    }
    return item?.id || null;
  };

  const handleSearchChange = (e, value) => {
    if (!value || typeof value === 'string') {
      setSelectedItem(null);
      setFilteredList([]);
      setSelectedItemTrailIds([]);
      return;
    }

    setSelectedItem(value);

    if (getItemType(value) === 'course') {
      setSelectedItemTrailIds(courseTrailsIndex.get(getItemIdentity(value)) || []);
    } else {
      setSelectedItemTrailIds([]);
    }

    const filteredCoursesByCategory = filterCoursesByCategory(courseList || []);
    const trailsForSearch = shouldHideTrailsByCategory ? [] : (trailList || []);
    const combined = [...filteredCoursesByCategory, ...trailsForSearch];
    const listToFilter = type === 'all' ? combined : type === 'courses' ? filteredCoursesByCategory : trailsForSearch;
    const selectedIdentity = getItemIdentity(value);
    const selectedType = getItemType(value);

    const filtered = listToFilter.filter((item) => {
      const itemIdentity = getItemIdentity(item);
      const itemType = getItemType(item);
      return itemIdentity && selectedIdentity && itemType === selectedType && itemIdentity === selectedIdentity;
    });

    setFilteredList(filtered);
  };

  const filterSearchOptions = (options, { inputValue }) => {
    const query = normalizeText(inputValue);
    if (!query) return options;

    return options.flatMap((option) => {
      const nameMatches = normalizeText(option?.name || '').includes(query);
      if (nameMatches) return [{ ...option, __searchLabel: option?.name || '' }];

      const lessons = getCourseLessons(option);
      const matchedLesson = lessons.find((lesson) =>
        normalizeText(lesson?.title || '').includes(query)
      );

      if (matchedLesson) {
        return [
          {
            ...option,
            __searchLabel: `${matchedLesson?.title || ''} - ${option?.name || ''}`,
          },
        ];
      }

      return [];
    });
  };

  const getAutocompleteOptionLabel = (option) => {
    if (typeof option === 'string') return option;
    return option?.__searchLabel || option?.name || '';
  };

  const matchesSelectedCourse = (courseItem) => {
    if (!selectedItem) return true;
    if (getItemType(selectedItem) !== 'course') return false;
    return getItemIdentity(courseItem) === getItemIdentity(selectedItem);
  };

  const matchesSelectedTrail = (trailItem) => {
    if (!selectedItem) return true;

    if (getItemType(selectedItem) === 'trail') {
      return getItemIdentity(trailItem) === getItemIdentity(selectedItem);
    }

    if (getItemType(selectedItem) === 'course' && selectedItemTrailIds.length > 0) {
      return selectedItemTrailIds.includes(getItemIdentity(trailItem));
    }

    return false;
  };

  const filterCoursesByCategory = (list = []) => {
    if (selectedCategory === 'all') return list;
    return list.filter((course) => (course?.category_name || '') === selectedCategory);
  };

  const shouldHideTrailsByCategory = selectedCategory !== 'all';

  const filterCourses = (list) => {
    if (filterType === 'courses') return list;

    if (filterType === 'trails') return [];

    if (filterType === 'required') {
      return list.filter(
        (c) =>
          c?.required_course === true ||
          c?.company_course?.show_required === true
      );
    }

    return list;
  };

  const filterTrails = (list) => {
    if (filterType === 'trails') return list;

    if (filterType === 'courses') return [];

    if (filterType === 'required') {
      return list.filter((t) => t?.required_trail === true);
    }

    return list;
  };

  const handleAutocompleteChangeAcademy = (e, value) => {
    setAcademyName(value ? value.name : "");

    if (value) {
      const filtered = academyList.filter((academy) =>
        academy.name.toLowerCase().includes(value.name.toLowerCase())
      );

      setFilteredAcademy(filtered);
      setSelectedAcademy(value);
    } else {
      setFilteredAcademy([]);
      setSelectedAcademy(null);
    }
  };


  const onActionClick = async (courseItem) => {
    const courseId = courseItem?.id;
    const currentEnrollment = courseItem?.id_enrollment;

    try {
      const { data: lesson } = await LessonData.getNextLesson(
        courseId,
        userId,
        currentEnrollment ? { id_enrollment: currentEnrollment } : {}
      );
      const id = lesson?.[0]?.id || '';
      history.replace(
        `/course/${courseId}/learn/${id}${
          currentEnrollment ? `?id_enrollment=${currentEnrollment}` : ''
        }`
      );
    } catch {
      history.replace(
        `/course/${courseId}/learn${
          currentEnrollment ? `?id_enrollment=${currentEnrollment}` : ''
        }`
      );
    }
  };

  const onActionClickGoToTrail = (trailId, typeParam, courseId = null) => {
    if (typeParam === 'progress') {
      history.replace(`trail/${trailId}/learn?course=${courseId}&progress=true`);
    } else if (typeParam === 'finished') {
      history.replace(`trail/${trailId}/learn?course=${courseId}&finished=true`);
    } else {
      history.replace(`trail/${trailId}/learn`);
    }
  };

  const onActionClickAcademy = async (id) => {
    try {
      history.replace(`/academy-ia/${id}`);
    } catch (error) {
      history.replace(`/dashboard`);
    }
  };

  const handleEmpty = (typeEmpty) => (
    <Box width="100%" className={classes.withoutContent}>
      <img src="/images/undraw_learning.svg" alt="Learning" />
      <div>
        <Typography className={classes.withoutContentText} variant="h1">
          {t('label:StudentContent.nothing_available')}
        </Typography>
        <Typography className={classes.withoutContentDescription}>
          {t('label:StudentContent.request_admin')}
        </Typography>
        <Link to="/available-content">
          <span className={classes.link}>
            {t('label:StudentContent.available_content')}
            <ArrowForwardRoundedIcon />
          </span>
        </Link>
      </div>
    </Box>
  );

  const onShouldOpenModalRating = async () => {
    try {
      const dateNow = format(new Date(), 'MM-yyyy');
      const response = await RatingData.hasRatingPlatform(dateNow, userId);
      if (response?.data?.shouldOpenModal) setOpenRating(true);
    } catch (err) {
      console.error(err);
    }
  };

  const filteredCourseList = useMemo(
    () => filterCoursesByCategory(courseList),
    [courseList, selectedCategory]
  );

  const visibleTrails = useMemo(
    () => (shouldHideTrailsByCategory ? [] : trailList),
    [shouldHideTrailsByCategory, trailList]
  );

  const visibleStartTrails = useMemo(
    () => (shouldHideTrailsByCategory ? [] : startTrails),
    [shouldHideTrailsByCategory, startTrails]
  );

  const visibleInProgressTrails = useMemo(
    () => (shouldHideTrailsByCategory ? [] : trails),
    [shouldHideTrailsByCategory, trails]
  );

  const visibleFinishedTrails = useMemo(
    () => (shouldHideTrailsByCategory ? [] : finishedTrails),
    [shouldHideTrailsByCategory, finishedTrails]
  );

  const combinedList = useMemo(() => [...filteredCourseList, ...visibleTrails], [filteredCourseList, visibleTrails]);

  return (
    <div className="notranslate">
      <Box className={classes.root}>
        {openRating && company?.domain_company !== '2a48df24-a717-4934-9513-56c036d2f4d3' && (
          <ModalPlatform setOpen={setOpenRating} company={company?.domain_company} user={userId} />
        )}
        <StudentContentHeader />
        <Grid item xs={12}>
          <Tabs
            value={tab}
            className={classes.tabs}
            indicatorColor="primary"
            textColor="primary"
            onChange={(_, newVal) => setTab(newVal)}
            aria-label={t('tables:commons.tab')}
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            <CustomTab
              key={0}
              classes={{ root: classes.gradientButton }}
              label={
                <span className={classes.tabItemsTitle}>
                  <FormatListBulletedIcon />
                  <span>{t('menu:sidebar.student.my_contents')}</span>
                </span>
              }
            />
            <CustomTab
              key={1}
              label={
                <span className={classes.tabItemsTitle}>
                  <LayersOutlinedIcon />
                  <span style={{ color: 'white !important' }}>{t('menu:sidebar.student.ia_academy')}</span>
                </span>
              }
            />
          </Tabs>


          {/* Aba 1 - Cursos & Trilhas (unificada) */}
          <TabPanel value={tab} index={0}>
            <Box className={classes.content}>
              <Grid style={{ marginBottom: 12 }} container spacing={2} alignItems="center">
                <Grid item md={8} xs={12}>
                  <Autocomplete
                    fullWidth
                    freeSolo
                    clearOnEscape
                    id="combo-box-demo"
                    options={type === 'all' ? combinedList : type === 'courses' ? filteredCourseList : visibleTrails}
                    getOptionLabel={getAutocompleteOptionLabel}
                    filterOptions={filterSearchOptions}
                    onChange={handleSearchChange}
                    inputValue={searchInput}
                    onInputChange={(_, value) => {
                      setSearchInput(value || '');
                      setError(false);
                    }}
                    renderOption={(option) => (
                      <Typography variant="body2">{getAutocompleteOptionLabel(option)}</Typography>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        style={{ 
                          background: '#ffffff', 
                          border: 'none', 
                          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' 
                        }}                  
                        error={error}
                        margin="normal"
                        label={t('form:Courses.input_content_enrollment')}
                        variant="outlined"
                        helperText={error ? t('form:commons.no_options') : ''}
                      />
                    )}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <FormControl fullWidth variant="outlined" margin="normal">
                    <InputLabel id="course-category-filter-label">Categoria</InputLabel>
                    <Select
                      labelId="course-category-filter-label"
                      id="course-category-filter"
                      value={selectedCategory}
                      style={{ 
                        background: '#ffffff', 
                        border: 'none', 
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' 
                      }}                  
                        onChange={(event) => {
                        setSelectedCategory(event.target.value);
                        setSelectedItem(null);
                        setFilteredList([]);
                        setSelectedItemTrailIds([]);
                        setSearchInput('');
                      }}
                      label="Categoria"
                    >
                      <MenuItem value="all">Todas</MenuItem>
                      {courseCategories.map((category) => (
                        <MenuItem key={category} value={category}>
                          {category}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              {isLoading ? (
                <div className={classes.loading}>
                  <div>
                    <CircularProgress className={classes.loadingIcon} />
                  </div>
                  <div>Carregando Seus Conteúdos</div>
                </div>
              ) : (
                <>
                  {type === 'all' && (
                    <>
                      <Box display="flex" mb={5} gap={2}>
                        <Chip
                          className={classes.filterChip}
                          label="Todos"
                          color="primary"
                          variant={filterType !== "all" ? "outlined" : undefined}
                          onClick={() => setFilterType("all")}
                          clickable
                        />
                        <Chip
                            className={classes.filterChipRequired}
                            label="Obrigatórios"
                            variant={filterType === "required" ? "default" : "outlined"}
                            style={
                              filterType === "required"
                                ? {
                                  backgroundColor: '#E03838',
                                  color: '#FFFFFF',
                                  border: '1px solid #E03838'
                                }
                                : {
                                  borderColor: '#E03838',
                                  color: '#E03838'
                                }
                            }
                            onClick={() => setFilterType("required")}
                            clickable
                          />
                        <Chip
                          className={classes.filterChip}
                          label="Cursos"
                          color="primary"
                          variant={filterType !== "courses" ? "outlined" : undefined}
                          onClick={() => setFilterType("courses")}
                          clickable
                        />

                        <Chip
                          className={classes.filterChip}
                          label="Trilhas"
                          color="primary"
                          variant={filterType !== "trails" ? "outlined" : undefined}
                          onClick={() => setFilterType("trails")}
                          clickable
                        />
                      </Box>

                      {(startCourses.length === 0 && visibleStartTrails.length === 0 && courses.length === 0 && visibleInProgressTrails.length === 0 && finishedCourses.length === 0 && visibleFinishedTrails.length === 0)
                        ? handleEmpty('conteudos')
                        : (
                          <>
                            {/* DISPONÍVEL */}
                            {(showCourses && startCourses.length > 0) || (showTrails && visibleStartTrails.length > 0) ? (
                              <Box width="100%" className={classes.bottomSpacing}>
                                {selectedItem === null && (
                                  <Typography className={classes.title} variant="h4">
                                    {t('label:StudentContent.label_available_to_you')}
                                  </Typography>
                                )}
                                <ProgressAllSlider
                                  onActionClickCourse={onActionClick}
                                  onActionClickGoToTrail={onActionClickGoToTrail}
                                  trails={
                                    selectedItem
                                      ? filterTrails(visibleStartTrails.filter(matchesSelectedTrail))
                                      : filterTrails(visibleStartTrails)
                                  }
                                  courses={
                                    selectedItem
                                      ? filterCourses(filterCoursesByCategory(startCourses).filter(matchesSelectedCourse))
                                      : filterCourses(filterCoursesByCategory(startCourses))
                                  }
                                />
                              </Box>
                            ) : null}
                            {/* EM ANDAMENTO */}
                            {(showCourses && courses.length > 0) || (showTrails && visibleInProgressTrails.length > 0) ? (
                              <Box width="100%" className={classes.bottomSpacing}>
                                {selectedItem === null && (
                                  <Typography className={classes.title} variant="h4">
                                    {t('label:StudentContent.label_in_progress')}
                                  </Typography>
                                )}
                                <ProgressAllSlider
                                  onActionClickCourse={onActionClick}
                                  onActionClickGoToTrail={onActionClickGoToTrail}
                                  trails={
                                    selectedItem
                                      ? filterTrails(visibleInProgressTrails.filter(matchesSelectedTrail))
                                      : filterTrails(visibleInProgressTrails)
                                  }
                                  courses={
                                    selectedItem
                                      ? filterCourses(filterCoursesByCategory(courses).filter(matchesSelectedCourse))
                                      : filterCourses(filterCoursesByCategory(courses))
                                  }
                                />
                              </Box>
                            ) : null}

                            {/* CONCLUÍDOS */}
                            {(showCourses && finishedCourses.length > 0) || (showTrails && visibleFinishedTrails.length > 0) ? (
                              <Box width="100%" className={classes.bottomSpacing}>
                                {selectedItem === null && (
                                  <Typography className={classes.title} variant="h4">
                                    {t('label:StudentContent.finished')}
                                  </Typography>
                                )}
                                <ProgressAllSlider
                                  onActionClickCourse={onActionClick}
                                  onActionClickGoToTrail={onActionClickGoToTrail}
                                  finishedTrailsAndCourses={true}
                                  trails={
                                    selectedItem
                                      ? filterTrails(visibleFinishedTrails.filter(matchesSelectedTrail))
                                      : filterTrails(visibleFinishedTrails)
                                  }
                                  courses={
                                    selectedItem
                                      ? filterCourses(filterCoursesByCategory(finishedCourses).filter(matchesSelectedCourse))
                                      : filterCourses(filterCoursesByCategory(finishedCourses))
                                  }
                                />
                              </Box>
                            ) : null}
                          </>
                        )
                      }
                    </>
                  )}
                </>
              )}
            </Box>
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <Box className={classes.content}>
              <Grid item md={8} xs={12}>
                <Autocomplete
                  fullWidth
                  freeSolo
                  clearOnEscape
                  id="combo-box-demo"
                  options={academyList}
                  getOptionLabel={(option) => option.name || ''}
                  onChange={(event, value) => {
                    if (tab === 1) {
                      handleAutocompleteChangeAcademy(event, value)
                    }
                  }}
                  onInput={() => setError(false)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      style={{ background: '#fff' }}
                      error={error}
                      margin="normal"
                      label={t('form:Courses.input_content_enrollment')}
                      variant="outlined"
                      helperText={error ? t('form:commons.no_options') : ''}
                    />
                  )}
                />
              </Grid>
              <Box className={classes.content}>
                <>
                  {Object.entries(academy || {}).map(([categoryName, items]) => {
                    const visibleItems = selectedAcademy
                      ? items.filter((academy) => academy.name === selectedAcademy.name)
                      : items;
                    if (visibleItems.length === 0) return null;
                    return (
                      <Box key={categoryName} width="100%" className={classes.bottomSpacing}>
                        <Typography className={classes.title} variant="h4">
                          {categoryName}
                        </Typography>
                        <ProgressAcademyIASlider
                          onActionClick={onActionClickAcademy}
                          courses={visibleItems}
                        />
                      </Box>
                    );
                  })}
                </>
              </Box>
            </Box>
          </TabPanel>
        </Grid>
      </Box>
    </div>
  );
}
